import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'my-6 flex flex-col lg:mt-12 lg:gap-12',
    container: 'container flex flex-col',
    headFixed: 'z-1 h-fit w-full gap-2 bg-white py-1',
    filters:
      'flex-center container flex justify-between gap-4 max-md:flex-row-reverse',
    actionsList:
      'relative mt-8 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3',
    notFound: 'mt-12 flex flex-col gap-24',
    pagination: 'flex justify-center'
  },
  variants: {
    color: {
      primary: 'text-black'
    }
  },
  defaultVariants: {
    color: 'primary'
  }
});
